import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';

interface BenefitCardProps {
  backgroundColor: string;
  title?: string;
  titleColor?: string;
  mainText: string;
  subText: string;
  badge?: string;
  src: string;
  href: string;
  className?: {
    wrapper?: string;
    textWrapper?: string;
  };
}

const isExternalLink = (href: string) => {
  return href.startsWith('http://') || href.startsWith('https://');
};

export const BenefitCard = ({
  backgroundColor,
  title,
  titleColor = 'text-Gray-600',
  mainText,
  subText,
  badge,
  src,
  href,
  className,
}: BenefitCardProps) => {
  const isExternal = isExternalLink(href);

  return (
    <CustomLink
      href={href}
      target={isExternal ? '_blank' : undefined}
      className="group block rounded-large p-20 transition-transform duration-200 ease-out active:scale-[0.99]"
      style={{
        backgroundColor,
        boxShadow: '8px 10px 40px 0px rgba(0, 0, 0, 0.03)',
      }}
    >
      <div
        className={cn('flex flex-row mobile-sm:flex-col', className?.wrapper)}
      >
        <div className="flex min-w-0 flex-1 flex-col justify-center">
          {title && (
            <p className={`typo-caption1 ${titleColor} font-600`}>{title}</p>
          )}
          <div className={cn('flex flex-col', className?.textWrapper)}>
            <p className="font-700 leading-6 typo-body3">{mainText}</p>
            <div className="-mt-2 flex items-center">
              <p className="font-700 leading-6 typo-body3">{subText}</p>
              {badge && (
                <span className="ml-2 flex size-16 items-center justify-center rounded-pill bg-O-500 px-5 py-4 font-700 text-Gray-white typo-caption2">
                  {badge}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="flex shrink-0 items-end justify-end">
          <Image
            alt={subText}
            width={60}
            height={60}
            sizes="60px"
            className="size-60 rounded-small transition-transform duration-200 ease-out group-hover:scale-110"
            src={src}
          />
        </div>
      </div>
    </CustomLink>
  );
};
